import script from "./NoteLabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./NoteLabel.vue?vue&type=script&setup=true&lang=ts"

import "./NoteLabel.vue?vue&type=style&index=0&id=75754b6a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75754b6a"]])

export default __exports__